export { default as TOAST_CLOSE } from "./icons/TOASTER_CLOSE.svg";
export { default as VE_ICON_PURPLE } from "./branding/VE_ICON.svg";
export { default as VE_ICON_GREY } from "./branding/VE_ICON_GREY.svg";
export { default as BACK_ICON } from "./icons/BACK_ICON.svg";
export { default as TOAST_ERROR } from "./icons/TOAST_ERROR.svg";
export { default as TOAST_SUCCESS } from "./icons/TOAST_SUCCESS.svg";
export { default as TOAST_WARNING } from "./icons/TOAST_WARNING.svg";
export { default as TOAST_INFO } from "./icons/TOAST_INFO.svg";
export { default as VE_TEXTICON } from "./branding/vericapNameLogo.svg";
export { default as NO_PERMISSION } from "./icons/NO_PERMISSION.svg";

export { default as DASHBOARD_ICON } from "./branding/dashboardIcon.svg";
export { default as DASHBOARD_SELECTED_ICON } from "./branding/dashboardSelectedIcon.svg";
export { default as SHARED_WITH_ICON_ACTIVE } from "./icons/SharedWithMeActive.svg";
export { default as SHARED_WITH_ICON } from "./icons/SharedWithMe.svg";
export { default as SETUP_GUIDE_ICON } from "./setup-guide/SETUP_GUIDE.svg";
export { default as SETUP_GUIDE_SELECTED_ICON } from "./setup-guide/SETUP_GUIDE_ACTIVE.svg";
export { default as TEAMS_SELECTED } from "./icons/TEAMS_SELECTED.svg";
export { default as TEAMS_UNSELECTED } from "./icons/TEAMS_UNSELECTED.svg";
export { default as ORGANISATION_SELECTED_ICON } from "./branding/orgSelectedIcon.svg";
export { default as ORGANISATION_ICON } from "./branding/organisationIcon.svg";
export { default as USER_ROLE_ICON } from "./branding/userRoleIcon.svg";
export { default as USER_ROLE_SELECTED_ICON } from "./branding/userRoleIconSelected.svg";
export { default as PROJECT_SELECTED_ICON } from "./branding/projectSelected.svg";
export { default as PROJECT_ICON } from "./branding/projectIcon.svg";
export { default as WALLET_SELECTED_ICON } from "./branding/walletSelected.svg";
export { default as ADVANCE_FILTERS } from "./icons/ADVANCE_FILTERS.svg";
export { default as WALLET_ICON } from "./branding/walletIcon.svg";
export { default as LIVE_STATUS } from "./icons/LIVE_STATUS.svg";
export { default as SETTINGS } from "./icons/settings.svg";
export { default as SETTINGS_ACTIVE } from "./icons/settingsActive.svg";
export { default as HELP } from "./icons/help.svg";
export { default as PROFILE_DETAILS } from "./icons/ProfileDetails.svg";
export { default as PROFILE_DOTS } from "./icons//profileDots.svg";
export { default as UPLOAD_ICON } from "./branding/uploadIcon.svg";
export { default as SOMETHING_WENT_WRONG } from "./icons/No connection.svg";
export { default as INFO_ICON } from "./icons/INFO_ICON.svg";
export { default as LOCATION_BLUE } from "./icons/LocationBlue.svg";
export { default as ACCOUNT_BLOCKED } from "./icons/ACCOUNT_BLOCKED.svg";
export { default as ALERT_ERROR_NEW } from "./icons/alert_new_error.svg";
export { default as BELL_ICON } from "./icons/bell-icon.svg";
export { default as BELL_ICON_ACTIVE } from "./icons/bell-icon-active.svg";
export { default as NO_ACCESS_MODAL_ICON } from "./icons/User Password.svg";

export { default as LAPTOP } from "./icons/laptop.svg";
export { default as ANDROID } from "./icons/android.svg";
export { default as IOS } from "./icons/ios.svg";
export { default as QUESTION_MARK } from "./icons/questionMark.svg";
export { default as NO_DATA_TABLE } from "./icons/noDataTable.svg";
export { default as EDIT } from "./icons/Edit.svg";
export { default as RESOLVE } from "./icons/resolve_tick.svg";
export { default as LINK_BROKEN } from "./icons/LINK_BROKEN.svg";
export { default as LINK_GREY } from "./icons/LINK_GREY.svg";
export { default as LINK_CHAIN_WHITE } from "./icons/LinkWhite.svg";
export { default as LINK_CHAIN_GREY } from "./icons/LinkChainGrey.svg";
export { default as WARNING_TRIANGLE } from "./icons/warning-triangle.svg";
export { default as WARNING_TRIANGLE_RED } from "./icons/WARNING_TRIANGLE_RED.svg";

export { default as DASHBOARDBANNER } from "./icons/dashboardBanner.svg";
export { default as DASHBOARDCHART } from "./icons/chartDashboard.svg";
export { default as DASHBOARDCHARTBLUR } from "./icons/chartDashboardBlur.svg";
export { default as RIGHTARROW } from "./icons/rightArrow.svg";
export { default as TWOFA_ICON } from "./icons/2FA.svg";
export { default as TRANSFER_ICON } from "./icons/transferUser.svg";
export { default as BENEFICIERY_ICON } from "./icons/beneficieryUser.svg";

export { default as MONITORING_MODAL } from "./MONITORING_MODAL.png";
export { default as EXTERNAL_PURPLE_ICON } from "./icons/Purple_external_icon.svg";
export { default as PLUS_ICON_GREY } from "./icons/PLUS_ICON_GREY.svg";

//project management
export { default as GRAY_PLUS_ICON } from "./icons/gray-plus.svg";
export { default as GRAY_CHECKLIST_ICON } from "./icons/gray-checklist.svg";
export { default as GRAY_GRID_ICON } from "./icons/gray-grid.svg";
export { default as GRAY_DOWNLOAD_ICON } from "./icons/gray-download.svg";

export { default as GEO } from "./fileType/GEO.svg";
export { default as DOC } from "./fileType/DOC.svg";
export { default as IMG } from "./fileType/IMG.svg";
export { default as JSN } from "./fileType/JSN.svg";
export { default as KML } from "./fileType/KML.svg";
export { default as KMZ } from "./fileType/KMZ.svg";
export { default as PDF } from "./fileType/PDF.svg";
export { default as PRJ } from "./fileType/PRJ.svg";
export { default as SHP } from "./fileType/SHP.svg";
export { default as XLSX } from "./fileType/XLSX.svg";
export { default as PPT } from "./fileType/PPT.svg";
export { default as DOCX } from "./fileType/DOCX.svg";
export { default as TXT } from "./fileType/TXT.svg";
export { default as RTF } from "./fileType/RTF.svg";
export { default as ODT } from "./fileType/ODT.svg";
export { default as HTML } from "./fileType/HTML.svg";
export { default as HTM } from "./fileType/HTM.svg";
export { default as MD } from "./fileType/MD.svg";
export { default as XLS } from "./fileType/XLS.svg";
export { default as CSV } from "./fileType/CSV.svg";
export { default as ODS } from "./fileType/ODS.svg";
export { default as XLSM } from "./fileType/XLSM.svg";
export { default as XLT } from "./fileType/XLT.svg";
export { default as XLTX } from "./fileType/XLTX.svg";
export { default as PPTX } from "./fileType/PPTX.svg";
export { default as ODP } from "./fileType/ODP.svg";
export { default as PPS } from "./fileType/PPS.svg";
export { default as PPSX } from "./fileType/PPSX.svg";
export { default as KEY } from "./fileType/KEY.svg";
export { default as POT } from "./fileType/POT.svg";
export { default as POTX } from "./fileType/POTX.svg";
export { default as XML } from "./fileType/XML.svg";
export { default as SHX } from "./fileType/SHX.svg";
export { default as DBF } from "./fileType/DBF.svg";
export { default as GPKG } from "./fileType/GPKG.svg";
export { default as TIFF } from "./fileType/TIFF.svg";
export { default as TIF } from "./fileType/TIF.svg";
export { default as GML } from "./fileType/GML.svg";
export { default as DXF } from "./fileType/DXF.svg";
export { default as VID } from "./fileType/VID.svg";
export { default as ZIP } from "./fileType/Zip.svg";

export { default as VIDEO_TYPE } from "./fileType/videoType.svg";

export { default as CLOSE } from "./fileType/CROSS.svg";

export { default as WITHDRAW_ICON } from "./walletIcons/withdraw.svg";
export { default as RECEIVED_ICON } from "./walletIcons/recieved.svg";
export { default as TRANSACTION_DRAWER } from "./icons/transactionDrawer.svg";
export { default as COPY_DRAWER } from "./icons/copyDrawer.svg";
export { default as INSURANCE } from "./icons/Insurance.svg";
export { default as THUNDER } from "./icons/thunder.svg";
export { default as DOWNLOAD } from "./icons/download.svg";
export { default as DOWNLOAD_BRAND } from "./icons/downloadBrand.svg";
export { default as TEMP_IMG } from "./temp/pexels-pixabay-159045.jpg";

// SDG's
export { default as NP } from "./sdg/NP.png";
export { default as LBW } from "./sdg/LBW.png";
export { default as PJI } from "./sdg/PJI.png";
export { default as DEG } from "./sdg/DEG.png";
export { default as PG } from "./sdg/PG.png";
export { default as III } from "./sdg/III.png";
export { default as CWS } from "./sdg/CS.png";
export { default as RCP } from "./sdg/RCP.png";
export { default as GWB } from "./sdg/GW.png";
export { default as CA } from "./sdg/CA.png";
export { default as LL } from "./sdg/LL.png";
export { default as SCC } from "./sdg/SCC.png";
export { default as RI } from "./sdg/RI.png";
export { default as QE } from "./sdg/QE.png";
export { default as ZH } from "./sdg/ZH.png";
export { default as GE } from "./sdg/GE.png";
export { default as ACE } from "./sdg/ACE.png";

export { default as PURPLE_FILLED_ICON } from "./branding/purple_filled_icon.svg";

export { default as RISK_ASSES } from "./temp/Frame 427321056.svg";
export { default as COMING_SOON_PERFORMANCE } from "./branding/performance.svg";
export { default as COMING_SOON_TEXT } from "./branding/coming_soon_outfit.svg";
export { default as STAKEHOLDER_LOGO } from "./icons/stakeholderLogo.svg";

export { default as COPY_GREY } from "./walletIcons/COPY_GREY.svg";
export { default as GROUP } from "./walletIcons/GROUP.svg";
export { default as STARS } from "./icons/bi_stars.svg";

// INVEST

export { default as INSURANCE_UMBRELLA } from "./Invest/INSURANCE.svg";
export { default as INFO } from "./Invest/INFO.svg";
export { default as FILLED_INFO } from "./Invest/FILLED_INFO.svg";
export { default as FILLED_PURPLE_INFO } from "./Invest/FILLED_PURPLE_INFO.svg";
export { default as PURPLE_INFO } from "./Invest/PURPLE_INFO.svg";
export { default as WALLET } from "./Invest/WALLET.svg";
export { default as TEMP_IMG_PLACEHOLDER } from "./temp/ImagePlaceholder.svg";

export { default as DROPDOWN } from "./walletIcons/chevron_dropdown.svg";
export { default as BANK_ICON } from "./walletIcons/bank_icon.svg";

export { default as PROFILE_ICON_FILLED_GREY } from "./icons/PROFILE_ICON_FILLED_GREY.svg";

export { default as SUPPORT } from "./icons/Support.svg";
export { default as PROFILE_GREY } from "./icons/profileGrey.svg";
export { default as PROFILE_GREY_NEW } from "./icons/profileGreyNew.svg";
export { default as PROFILE_GREY_NEW_SELECTED } from "./icons/profileGreyNewSelected.svg";
export { default as PROFILE_ACTIVE } from "./icons/profileActive.svg";
export { default as ARROW_UP } from "./icons/arrowUp.svg";
export { default as ARROW_DOWN } from "./icons/arrowDown.svg";
export { default as CLOCK } from "./icons/clock.svg";
export { default as CHECKLIST } from "./icons/Checklist.svg";
export { default as DOCUMENT_CHECK } from "./icons/DocumentCheck.svg";
export { default as PERSONAL_DETAILS } from "./icons/PersonalDetails.svg";
export { default as SQUARE_MINUS } from "./icons/SquareMinus.svg";
export { default as PROJECT } from "./icons/Project.svg";
export { default as BANK } from "./icons/Bank.svg";
export { default as BLOG } from "./icons/Blog.svg";
export { default as EXPIRED } from "./icons/Expired.svg";

export { default as ACTIVE_CHECKLIST_ICON } from "./icons/CHECKLIST_ACTIVE.svg";
export { default as CHECKLIST_ICON } from "./icons/CHECKLIST_ICON.svg";

// v2 Navigation

export { default as PROJECT_DETAILS_ICON } from "./icons/Navigation-icons/PROJECT_DETAILS_ICON.svg";
export { default as PROJECT_DETAILS_ACTIVE_ICON } from "./icons/Navigation-icons/PROJECT_DETAILS_ACTIVE_ICON.svg";
export { default as CARBON_INVENTORY_ICON } from "./icons/Navigation-icons/CARBON_INVENTORY_ICON.svg";
export { default as CARBON_INVENTORY_DISABLED_ICON } from "./icons/Navigation-icons/CARBON_INVENTORY_DISABLED_ICON.svg";
export { default as DEVELOPER_DETAILS_ICON } from "./icons/Navigation-icons/DEVELOPER_DETAILS_ICON.svg";
export { default as DEVELOPER_DETAILS_ACTIVE_ICON } from "./icons/Navigation-icons/DEVELOPER_DETAILS_ACTIVE_ICON.svg";
export { default as FINANCIALS_IMPACT_ICON } from "./icons/Navigation-icons/FINANCIALS_IMPACT_ICON.svg";
export { default as FINANCIALS_IMPACT_ACTIVE_ICON } from "./icons/Navigation-icons/FINANCIALS_IMPACT_ACTIVE_ICON.svg";
export { default as KYB_ICON } from "./icons/Navigation-icons/KYB_ICON.svg";
export { default as KYB_ACTIVE_ICON } from "./icons/Navigation-icons/KYB_ACTIVE_ICON.svg";
export { default as QUESTIONNAIRE_ICON } from "./icons/Navigation-icons/QUESTIONNAIRE_ICON.svg";
export { default as QUESTIONNAIRE_ACTIVE_ICON } from "./icons/Navigation-icons/QUESTIONNAIRE_ACTIVE_ICON.svg";
export { default as QUESTIONNAIRE_ACTIVE_DISABLED_ICON } from "./icons/Navigation-icons/QUESTIONNAIRE_ACTIVE_DISABLED_ICON.svg";
export { default as PROJECT_DETAILS_DISABLED_ICON } from "./icons/Navigation-icons/BASIC_DISABLED.svg";
export { default as DEVELOPER_DETAILS_DISABLED_ICON } from "./icons/Navigation-icons/DEVELOPER_DISABLED.svg";
export { default as KYB_DISABLED_ICON } from "./icons/Navigation-icons/KYB_DISABLED.svg";
export { default as FINANCIALS_IMPACT_DISABLED_ICON } from "./icons/Navigation-icons/FINANCIALS_DISABLED.svg";
export { default as DOCUMENTS_DISABLED_ICON } from "./icons/Navigation-icons/DOCUMENT_DISABLED.svg";
export { default as MARKETPLACE_ICON } from "./icons/Navigation-icons/MARKETPLACE_ICON.svg";
export { default as MARKETPLACE_ACTIVE_ICON } from "./icons/Navigation-icons/MARKETPLACE_ACTIVE_ICON.svg";

export { default as RFX_ICON } from "./icons/Navigation-icons/RFX_ICON.svg";
export { default as RFX_DISABLED_ICON } from "./icons/Navigation-icons/RFX_DISABLED_ICON.svg";
export { default as DOCUMENTS_ICON } from "./icons/Navigation-icons/DOCUMENT_ICON.svg";
export { default as DOCUMENTS_ACTIVE_ICON } from "./icons/Navigation-icons/DOCUMENT_ACTIVE_ICON.svg";

export { default as SIGN_AGREEMENT_ICON_WHITE } from "./icons/SIGN_AGREEMENT_ICON_WHITE.svg";
export { default as SIGN_AGREEMENT_ICON_GREY } from "./icons/SIGN_AGREEMENT_ICON_GREY.svg";
export { default as CLOSE_ICON_WHITE } from "./icons/CLOSE_ICON_WHITE.svg";

export { default as SETUP_GUIDE_COMPLETED_ICON } from "./icons/SETUP_GUIDE_COMPLETED_ICON.svg";
export { default as SETUP_GUIDE_EMPTY_CHECKBOX } from "./icons/SETUP_GUIDE_EMPTY_CHECKBOX.svg";

// Setup Guide

export { default as SETUP_GUIDE_SUCCESS } from "./setup-guide/SETUP_GUIDE_SUCCESS.svg";
export { default as SETUP_GUIDE_PENDING } from "./setup-guide/SETUP_GUIDE_PENDING.svg";
export { default as REJECTED_CROSS } from "./setup-guide/REJECTED_CROSS.svg";

export { default as SHAREHOLDER_GUIDE_1 } from "./setup-guide/shareholder_guide_1.svg";
export { default as SHAREHOLDER_GUIDE_2 } from "./setup-guide/shareholder_guide_2.svg";
export { default as SHAREHOLDER_GUIDE_3 } from "./setup-guide/shareholder_guide_3.svg";

export { default as FOLDER_ICON } from "./setup-guide/File.svg";
export { default as FILE_ICON } from "./setup-guide/Folder.svg";
export { default as ADD_ICON } from "./icons/Add.svg";
export { default as ADD_BLUE_ICON } from "./icons/Add-Blue.svg";
export { default as READ_COMMENT } from "./icons/Read.svg";
export { default as UNREAD_COMMENT } from "./icons/Unread.svg";
export { default as EDIT_PENCIL } from "./icons/PencilEdit.svg";
export { default as UPLOAD_BLUE_ICON } from "./icons/Upload.svg";
export { default as WHITE_ADD } from "./icons/WhiteAdd.svg";

// Bundles
export { default as BUNDLES_PROJECT_LOCATION } from "./icons/BUNDLES_PROJECT_LOCATION.svg";
export { default as GREEN_TICK } from "./icons/GreenTick.svg";
export { default as InProgress } from "./icons/InProgress.svg";
export { default as InComplete } from "./icons/InComplete.svg";
export { default as notes } from "./icons/notes.svg";
export { default as buildings } from "./icons/buildings.svg";
export { default as NO_MAP } from "./icons/EmptyMap.png";
export { default as star } from "./icons/star.svg";
export { default as EMPTY_GRAPH } from "./icons/EMPTY_SPIDER.svg";
export { default as TICK } from "./icons/Tick.svg";
export { default as LOGO_WHITE } from "./icons/Logo-White.svg";
export { default as DOWNLOAD_BLACK } from "./icons/download1.svg";
export { default as FULLSCREEN } from "./icons/fullscreen.svg";
export { default as HELP_WHITE } from "./icons/Help_White.svg";
export { default as ZOOM_IN } from "./icons/zoom-in.svg";
export { default as ZOOM_OUT } from "./icons/zoom-out.svg";
export { default as LOCK } from "./icons/lock.svg";
export { default as VIEW_ALL } from "./icons/viewAll.svg";
export { default as DELETE_BLOCK } from "./icons/deleteBlock.svg";
export { default as DRAG_DROP } from "./icons/draganddrop.svg";
export { default as DRAG_DROP_TRANSPARENT } from "./icons/DRAG_DROP_TRANSPARENT.svg";
export { default as EDIT_ON_HOVER_PENCIL } from "./icons/editOnHoverPencil.svg";
export { default as VIEW_ALL_ON_HOVER } from "./icons/viewAllOnHover.svg";
export { default as COMING_SOON_TIMER } from "./icons/comingSoonTimer.svg";
export { default as FILE } from "./icons/File.svg";
export { default as ARROW_RIGHT } from "./icons/arrowRight.svg";
export { default as LOGO_SMALL } from "./icons/Doc_logo.svg";
export { default as UNSUPPORTED } from "./icons/Unsupported.svg";
export { default as New_Project_SVG } from "./icons/New_Project.svg";
export { default as FILTER_FUNNEL } from "./icons/filterFunnel.svg";
export { default as FILTER_FUNNEL_DISABLED } from "./icons/filterFunnelDisabled.svg";
export { default as EMOJI_ICON } from "./icons/emojiIcon.svg";
export { default as Attachment } from "./icons/Attachment.svg";
export { default as SEARCH_ICON } from "./icons/searchIcon.svg";
export { default as CHEVRON_LEFT } from "./icons/chevronLeft.svg";
export { default as CIRCLE_EXCLAMATION } from "./icons/circleExclamation.svg";

// Priority Icons
export { default as HIGH_PRIORITY } from "./priorityIcons/Arrow Up.svg";
export { default as MEDIUM_PRIORITY } from "./priorityIcons/mediumPriority.svg";
export { default as LOW_PRIORITY } from "./priorityIcons/Arrow Down.svg";
export { default as LOGOUT } from "./icons/LOGOUT.svg";
export { default as SORT_ARROW } from "./icons/SortArrow.svg";
export { default as DRAG } from "./icons/draggable.svg";
export { default as COMPANY_THUMBNAIL } from "./icons/Company_thumbnail.svg";
export { default as NO_IMAGE_TABLE } from "./icons/No_Image_State.svg";
export { default as EMPTY_IMPACT } from "./icons/Empty_impact.svg";
export { default as CHECKBOX_TICK } from "./icons/checkboxTick.svg";
export { default as NOSTAKEHOLDERTABLE } from "./icons/NoStakeholderTable.svg";
export { default as SHARE } from "./icons/share.svg";
export { default as PREVIEW } from "./icons/Preview.svg";
export { default as PREVIEW_PROJECT } from "./icons/PREVIEW_PROJECT.svg";
export { default as PREVIEW_PROJECT_DISABLED } from "./icons/PREVIEW_PROJECT_DISABLED.svg";
export { default as BIN } from "./icons/BIN.svg";
export { default as DUPLICATE } from "./icons/DUPLICATE.svg";
export { default as BUNDLE_ICON } from "./icons/BundleIcon.svg";
export { default as COPY_BRAND } from "./icons/copy_brand.svg";
export { default as ANDROID_MASCOT } from "./icons/Device Type/ANDROID.svg";
export { default as APPLE } from "./icons/Device Type/APPLE.svg";
export { default as WINDOWS } from "./icons/Device Type/WINDOWS.svg";
export { default as IPHONE } from "./icons/Device Type/IPHONE.svg";
export { default as DEFAULT_PROFILE } from "./icons/defaultProfile.svg";
export { default as EMPTYNOTEPAD } from "./icons/EmptyNotePad.svg";
export { default as PLUS_BRAND } from "./icons/Plus_Brand.svg";
export { default as EMPTY_STATE_BOOKMARKS } from "./icons/empty_state_bookmarks.svg";
export { default as SHARE_WHITE } from "./icons/share_white.svg";
export { default as CARBON_PROJECTS } from "./icons/carbon-projects.svg";
export { default as BUNDLE_BRAND } from "./icons/Bundle.svg";
export { default as LINK_BRAND_DASHBOARD } from "./icons/link_brand.svg";
export { default as PLUS_ADD } from "./icons/plusAdd.svg";
export { default as NO_FILES_STATE } from "./icons/noFilesImage.svg";
export { default as DATA_ROOM } from "./icons/data_room.svg";
export { default as EMPTY_TASK } from "./icons/EMPTY_TASK.svg";
export { default as UPLOAD_FOLDER } from "./icons/upload-folder.svg";
export { default as CREATE_FOLDER } from "./icons/create-folder.svg";
export { default as UPLOAD_FILE } from "./icons/upload-file.svg";
export { default as Empty_Risk } from "./icons/Empty_Risk.svg";
export { default as EMPTY_LIGHT_STATE } from "./icons/Empty State_No Data.svg";
export { default as ORG_ICON } from "./icons/org_icon.svg";
export { default as RIGHT_ARROW_ICON } from "./icons/right_arrow_icon.svg";
export { default as SWITCH_ORG } from "./icons/switch_org.svg";
export { default as BG_SHAPES } from "./branding/Bg_Shapes.svg";
export { default as COLLABORATORS } from "./icons/collaborator.svg";
export { default as COLLABORATORS_SELECTED } from "./icons/collaborator-selected.svg";
export { default as COLLABORATORS_DISABLED } from "./icons/collaborator-disabled.svg";
export { default as SEND_INVITE } from "./icons/send_invite.svg";
export { default as REVOKE_USER } from "./icons/Revoke_user.svg";
// export { default as REFRESH } from "./icons/Refresh.svg";
export { default as DEACTIVATE } from "./icons/Deactivate.svg";

export { default as DRAG_DROP_IMAGE } from "./icons/drag_drop_image.svg";
export { default as CAMERA_ON_HOVER } from "./icons/camera_onhover.svg";
export { default as SUNSET } from "./branding/sunset.svg";
export { default as REFRESH } from "./icons/Refresh.svg";
export { default as VE_SELLER } from "./branding/VE_SELLER.svg";
export { default as INBOX } from "./icons/InboxFilled.svg";
export { default as INBOX_REJECETD } from "./icons/Inbox_Rejected.svg";
export { default as COMBO_CHART } from "./icons/combo_chart.svg";
export { default as VIEW_QUILT } from "./icons/view_quilt.svg";
export { default as TEAMS } from "./icons/Teams.svg";
export { default as BUSINESS_INFO } from "./icons/Business.svg";

export { default as GLOBE } from "./icons/GLOBE.svg";
export { default as GLOBE_PURPLE } from "./icons/GLOBE_PURPLE.svg";
export { default as ADD_USER_ICON } from "./icons/ADD_USER_ICON.svg";
export { default as PURPLE_EXTERNAL_LINK } from "./icons/purple_external_link.svg";
export { default as MAIL } from "./icons/Mail.svg";
export { default as PENCIL_WHITE } from "./icons/pencil_white.svg";

export { default as INVESTOR_ICON } from "./roles/investor_icon.svg";
export { default as SALES_PARTNER } from "./roles/sales_partner.svg";
export { default as VERIFIER } from "./roles/verifier.svg";
export { default as EXPIRED_RED } from "./icons/expired-icon.svg";
export { default as ACCOUNT_SETTINGS } from "./icons/account_settings.svg";
export { default as ACCOUNT_SETTINGS_SELECTED } from "./icons/account_settings_selected.svg";

export { default as DELETE_ON_HOVER } from "./icons/delete-on-hover.svg";
export { default as PERMISSION_DESK } from "./branding/permission_desk.svg";
export { default as NEW_USER } from "./icons/Existing-user.svg";
export { default as WARNING } from "./icons/Warning.svg";
export { default as CFCC } from "./branding/CFCC.svg";
export { default as PUBLIC_FORM_AFTERSTATE } from "./branding/Public_form_afterstate.svg";
export { default as FACILITIES_ICON } from "./icons/Facilities.svg";
export { default as ACTIVE_FACILITIES_ICON } from "./icons/active_facilities.svg";
export { default as CRITICAL } from "./icons/Critical.svg";
